export const CHECKOUT_PAGE_TEXT = {
  MEMBERSHIP_HEADER: 'CHOOSE YOUR MEMBERSHIP PLAN',
  MEMBERSHIP_BUTTON: 'CONTINUE',
  FANZONE_SUBSCRIPTION_HEADER: 'FAN SUBSCRIPTION PRICING',
  FANZONE_SUBSCRIPTION_DESCRIPTION: 'Join today and get exclusive access to live streams, special content and the ability to chat in-private with our Anchors.',
};
